<template>
    <div>
        <template v-if="AtPembayaranPage">
            <font-awesome-icon icon="chevron-left" style="font-size: 50px; margin-left: 50px; cursor: pointer"
                class="my-4 no-print" @click="ResetSuratPenunjangStore" />
        </template>

        <div class="m-2">
            <div class="row">
                <div class="col-6">
                    <div class="d-flex align-items-center justify-content-start">
                        <img crossorigin="anonymous" class="img-fluid" :src="KlinikIMGUncached" />
                    </div>
                </div>
                <div class="col-6">
                    <div class="d-flex flex-column align-items-end justify-content-center h-100">
                        <p class="text-right">{{ KlinikName }}</p>
                        <p class="text-right alamat-klinik">{{ KlinikAddress }}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h4 class="text-center">
                        <u>
                            {{ CustomLetterTitle }}
                        </u>
                    </h4>
                </div>
                <div class="col-12">
                    <div class="text-center d-flex align-items-center justify-content-center">
                        <h5 class="mr-2">Nomor surat:</h5>

                        <template v-if="CurrentlyPrintingLetter">
                            <h5>{{ LetterNumber }}</h5>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-auto">
                                <input :value="LetterNumber" @input="ProxyChangeLetterNumber" type="text"
                                    :style="{ 'min-width': '200px', width: ((BaseLetterNumber && BaseLetterNumber.length) * 11) + 'px' }"
                                    class="form-control" />
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faChevronLeft);
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'SuratPenunjangFormsBaseHeader',
    props: {
        KlinikIMG: {
            type: String,
            required: true,
            default: '/img/new_logo.png'
        },
        KlinikName: {
            type: String,
            required: true
        },
        KlinikAddress: {
            type: String,
            required: true
        },
        LetterTitle: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            Base64IMGLogo: null
        }
    },
    watch: {
        KlinikIMG: {
            immediate: true,
            deep: true,
            handler(val) {
                this.getBase64FromUrl(val).then((res) => {
                    this.Base64IMGLogo = res
                })
            }
        }
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
    },
    computed: {
        ...mapState('SuratPenunjangStore', ['LetterNumber', 'CurrentlyPrintingLetter', 'AtPembayaranPage', 'BaseLetterNumber']),
        CustomLetterTitle() {
            switch (this.LetterTitle.toLowerCase()) {
                case 'surat sakit':
                    return 'Surat Keterangan Sakit'
                case 'surat resume medis':
                    return 'Resume Medis'
                default:
                    return this.LetterTitle
            }
        },
        KlinikIMGUncached() {
            return this.KlinikIMG + '?t=' + new Date().getTime()
        }
    },
    methods: {
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        ProxyChangeLetterNumber($evt) {
            this.SetLetterNumber($evt.target.value)
        },
        async getBase64FromUrl(url) {
            const imageData = await fetch(url, { mode: 'no-cors' });
            const blob = await imageData.blob();

            return new Promise((resolve) => {
                const reader = new FileReader();

                reader.readAsDataURL(blob);

                reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                };
            });
        }
    }
}
</script>

<style scoped>
.img-fluid {
    max-width: 30%;
}

.alamat-klinik {
    word-wrap: break-word;
    max-width: 70%;
}
</style>